import useOrganizations from "@/features/organizations/useOrganizations";
import { Box, Stack } from "@mui/material";
import { grey } from '@mui/material/colors';
import { getColor } from '@/pages/organization-orders/utils/performanceColors';

interface PerformanceIndicatorProps {
    orderedAt?: number;
    approvedAt?: number;
    sendingAt?: number;
    completedAt?: number;
}

const baseStyles = {
    backgroundColor: grey[400],
    borderRadius: "50%",
    width: "10px",
    height: "10px",
}

const PerformanceIndicator = ({ orderedAt, approvedAt, sendingAt, completedAt }: PerformanceIndicatorProps) => {
    const { currentOrganization } = useOrganizations();

    return (
        <Stack direction="row" gap={0.5}>
            <Box sx={{ ...baseStyles, backgroundColor: getColor(orderedAt, approvedAt, currentOrganization?.settings?.operationTiming?.review) }} />
            <Box sx={{ ...baseStyles, backgroundColor: getColor(approvedAt, sendingAt, currentOrganization?.settings?.operationTiming?.preparation) }} />
            <Box sx={{ ...baseStyles, backgroundColor: getColor(sendingAt, completedAt, currentOrganization?.settings?.operationTiming?.shipping) }} />
        </Stack>
    );
};

export default PerformanceIndicator;